import { Trans } from "@lingui/macro";
import { UiButton, UiDialogResponsive } from "@smp/ui";

export const DialogNoCreationPermissions = ({
  closeDialog,
  isOpen,
}: {
  closeDialog: () => void;
  isOpen: boolean;
}) => (
  <UiDialogResponsive
    title={
      <Trans>You do not have permission to create posts on the team</Trans>
    }
    open={isOpen}
    onClose={closeDialog}
    isButtonCloseHidden
    actionsRight={[
      <UiButton color="primary" onClick={closeDialog}>
        <Trans>OK</Trans>
      </UiButton>,
    ]}
  >
    <Trans>
      Request another role from the team owner or select another team to create
      posts.
    </Trans>
  </UiDialogResponsive>
);
